import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

const service_id = 1

class Application extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  createApplication = () => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "client/application/" + service_id,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  getAllApplications = app => {
    const request = new Request({
      data: {
        url: "clients/applications/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getApplicationsPagination = page => {
    const request = new Request({
      data: {
        url: "clients/applications/" + this.user.id + "?page=" + page,
        //token: "Bearer " + user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getPlasticTypes = () => {
    const request = new Request({
      data: {
        url: "plastic-types",
      },
    })

    const response = this.getRequest(request)
    return response
  }

  saveApplication = appForm => {
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        service_id: service_id,
        is_submitted: true,
        url: "clients/applications/plastic-bags-authorization",
        token: "Bearer " + this.user.token,
      },
    })

    //console.log("app details" + request)
    return this.postRequest(request)
  }

  getStatistics = () => {
    const request = new Request({
      data: {
        url: "client/statistics/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    return this.getRequest(request)
  }

  uploadFile = fileDetails => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  bulkFileUpload = files => {
    var uploadStatus = new Promise((resolve, reject) => {
      files.forEach(file => {
        this.uploadFile(file).then(response => {
          console.log("response from server upload")
          console.log(response)
        })
      })
    })

    uploadStatus.then(() => {
      return new Response({
        code: 200,
        message: "upload success",
        status: true,
      })
    })
  }

  getApplicationDetails = id => {
    //console.log(this.user)
    const request = new Request({
      data: {
        url: "application/" + id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getServiceAttachments = () => {
    const request = new Request({
      data: {
        url: "service/attachments/" + service_id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  downloadAttachment = file => {
    const request = new Request({
      data: {
        url: "service/download-attachment?file=" + file,
        //file: file,
        token: "Bearer " + this.user.token,
      },
    })

    return this.downloadRequest(request)
  }

  getConsumptionAreas = () => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // Changes October 2022

  /*
    Description:
      When applicant selects the purchase and use option, there should be a dropdown
      of all local companies where applicant will be purchasing the plastics from
    
    @return list of all local companies
  */
  getLocalSuppliers = () => {
    const request = new Request({
      data: {
        url: "plastics/local-suppliers",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  /*
    Description |
      For each consumption area, applicants are made to select the items they'd
      want to package. For instance, if the consumption area is Food Packaging, 
      applicants must select items such as, Chicken, Beef, etc. These are the actual
      items they will be packaging, for which they are requesting special use of 
      single-use plastics.
    
      This function will return a list of all consumption area items given a consumption 
      area id.

    @param {id - consumption area id}
    @return List of consumption area items

  */
  getConsumptionAreaItems = (id) => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas/" + id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  downloadAttachment = file => {
    const request = new Request({
      data: {
        url: "service/download-attachment?file=" + file,
        token: "Bearer " + this.user.token,
      },
    })

    return this.downloadRequest(request)
  }
}

export default Application
